import info from './info.svg?sprite';
import error from './error.svg?sprite';
import success from './success.svg?sprite';
import warning from './warning.svg?sprite';
import arrowLeft from './arrow-left.svg?sprite';
import arrowRight from './arrow-right.svg?sprite';
import close from './close.svg?sprite';
import wishlist from './wishlist.svg?sprite';
import copy from './copy.svg?sprite';
import spinner from './spinner.svg?sprite';
import play from './play.svg?sprite';
import checkboxDefault from './checkbox/checkbox-default.svg?sprite';
import checkboxActive from './checkbox/checkbox-active.svg?sprite';
import checkboxInactive from './checkbox/checkbox-inactive.svg?sprite';
import checkboxCheckedInactive from './checkbox/checkbox-checked-inactive.svg?sprite';
import truck from './truck.svg?sprite';
import returnCircle from './return.svg?sprite';
import filteringSorting from './filtering-sorting.svg?sprite';
import radioDefault from './radio-default.svg?sprite';
import radioSelected from './radio-selected.svg?sprite';
import deleteOutline from './delete-outline.svg?sprite';
import edit from './edit.svg?sprite';
import loadMore from './load-more.svg?sprite';
import list from './list.svg?sprite';
import cameraOutline from './camera-outline.svg?sprite';
import landscapeOutline from './landscape-outline.svg?sprite';
import instagram from './instagram.svg?sprite';
import facebook from './facebook.svg?sprite';
import alertInfo from './alert/alert-info.svg?sprite';
import alertError from './alert/alert-error.svg?sprite';
import alertSuccess from './alert/alert-success.svg?sprite';
import alertWarning from './alert/alert-warning.svg?sprite';
import subscribe from './subscribe.svg?sprite';
export default {
    info: info,
    error: error,
    success: success,
    warning: warning,
    arrowLeft: arrowLeft,
    arrowRight: arrowRight,
    wishlist: wishlist,
    close: close,
    copy: copy,
    spinner: spinner,
    play: play,
    checkboxDefault: checkboxDefault,
    checkboxActive: checkboxActive,
    checkboxInactive: checkboxInactive,
    checkboxCheckedInactive: checkboxCheckedInactive,
    truck: truck,
    returnCircle: returnCircle,
    filteringSorting: filteringSorting,
    radioDefault: radioDefault,
    radioSelected: radioSelected,
    deleteOutline: deleteOutline,
    edit: edit,
    loadMore: loadMore,
    list: list,
    cameraOutline: cameraOutline,
    landscapeOutline: landscapeOutline,
    instagram: instagram,
    facebook: facebook,
    alertInfo: alertInfo,
    alertError: alertError,
    alertSuccess: alertSuccess,
    alertWarning: alertWarning,
    subscribe: subscribe,
};
